import { MenuItemIndicator } from "../../../../../ui/menu/item-indicator.js";
import { MenuRadioItem } from "../../../../../ui/menu/radio-item.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/check.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-audio/components/menus/radio-item.tsx
/** @jsxImportSource react */
function RadioItem({ children, className, ...props }) {
	return /* @__PURE__ */ jsxs(MenuRadioItem, {
		className: (state) => cn("media-menu-radio-item", resolveClassName(className, state)),
		...props,
		children: [children, /* @__PURE__ */ jsx(MenuItemIndicator, {
			forceMount: true,
			className: "media-menu-item-indicator",
			children: /* @__PURE__ */ jsx(ForwardRef, { className: "media-menu-radio-item-icon" })
		})]
	});
}
//#endregion
export { RadioItem };

//# sourceMappingURL=radio-item.js.map